import { Str, str } from "@olton/string";

globalThis.Str = Str;
globalThis.str = str;
